import React from 'react'
import Modal from 'components/Modal'
import { Input, Select } from 'components/Form'
import debounce from 'debounce'
import Tabs from 'components/Tabs'
import Detail from 'components/Detail'
import calculateSize from 'components/CalculateSize'
import Button from 'components/Button'
import './editor.css'
import { Mutation } from 'react-apollo'
import { DELETE_OBJECT, GET_IMAGES } from 'operations/Object'
import { remove } from 'lodash'

export default class Editor extends React.Component {

    constructor(props) {
        super(props)
        this.state = {}

        this.handleChange = this.handleChange.bind(this)
        this.handleClose = this.handleClose.bind(this)
    }

    handleChange = ({ name, value }, type) => {
        const state = this.state
        if (type === 'number' && value > 0) {
            state[name] = +value
        } else if (type === 'number') { 
            delete state[name]
        } 

        else if (name === 'preset') {

            if (value) {
                const presets = {
                    INSTAGRAM_4_5: {
                        'scale.width': 1080,
                        'scale.height': 1350
                    },
                    INSTAGRAM_SQUARE: {
                        'scale.width': 1080,
                        'scale.height': 1080
                    },
                    INSTAGRAM_LANDSCAPE: {
                        'scale.width': 1080,
                        'scale.height': 566
                    },

                    FACEBOOK_COVER: {
                        'scale.width': 2037,
                        'scale.height': 754
                    },
                    FACEBOOK_PAGE_COVER: {
                        'scale.width': 1958,
                        'scale.height': 745
                    },
                    FACEBOOK_GROUP_COVER: {
                        'scale.width': 1640,
                        'scale.height': 922
                    },
                    FACEBOOK_EVENT_COVER: {
                        'scale.width': 1000,
                        'scale.height': 524
                    },
                    FACEBOOK_PROFILE: {
                        'scale.width': 2048,
                        'scale.height': 2048
                    },
                    FACEBOOK_AD_LINK: {
                        'scale.width': 1200,
                        'scale.height': 628
                    },
                    
                    MAILCHIMP: {
                        'scale.width': 600,
                        'scale.height': false
                    }
                }

                Object.keys(presets[value]).map((property) => {
                    if (presets[value][property]) {
                        return state[property] = presets[value][property]
                    }
                    else {
                        return delete state[property]
                    }
                })
            }
        }

        else if (value !== 'true') {
            delete state[name]
        }
        
        else {
            state[name] = value
        }
        
        this.setState({
            ...state
        })
    }

    handleDelete() {
        alert('delete')
    }

    handleClose() {
        if (this.props.onClose) {
            this.props.onClose()
        }
    }

    render () {

        const { object, image } = this.props
        // const state = flatten(this.state)
        
        const width = this.state['scale.width'] || 600

        const queryString = Object.keys(this.state).reduce((string, option) => {
            
            const separator = string.length > 0 ? '&' : ''
            return string + separator + option + '=' + this.state[option]

        }, '')

        console.log(queryString)

        // const uri = `http://localhost:3001/${ object }/${ name.split(' ').join('%20') }${ queryString ? '?' : '' }${ queryString }`
        const uri = `https://cdn.tueri.io/${ object }/${ image.originalName.split(' ').join('%20') }${ queryString ? '?' : '' }${ queryString }`

        const objectId = object

        return(
            <Modal>
                <div className='editor__imageContainer'>
                    <div className='editor__image' style={{ width, height: this.state['scale.height'] }}>
                        <img style={{ maxWidth: '100%', maxHeight: '100%' }} src={uri} alt='' />
                    </div>
                    <div className='editor__imageUrl'>{ uri }</div>
                </div>
                <div className='editor__options'>

                    <button className='editor__close' onClick={ this.handleClose }><i className='material-icons'>close</i></button>

                    <div className='padding'>
                        <Tabs
                            tabs={['Editor', 'Info']}
                        >
                            <div>
                                <h2>Presets</h2>
                                <Select label='Preset' name='preset' value={ this.state['preset'] } options={[ ['INSTAGRAM_4_5', 'Instagram - 4:5'], ['INSTAGRAM_SQUARE', 'Instagram - Square'], ['INSTAGRAM_LANDSCAPE', 'Instagram - Landscape'], ['FACEBOOK_COVER', 'Facebook - Cover'], ['FACEBOOK_PAGE_COVER', 'Facebook - Page Cover'], ['FACEBOOK_GROUP_COVER', 'Facebook - Group Cover'], ['FACEBOOK_EVENT_COVER', 'Facebook - Event Cover'], ['FACEBOOK_PROFILE', 'Facebook - Profile'], ['FACEBOOK_AD_LINK', 'Facebook - Ad Link'], ['MAILCHIMP', 'Mailchimp'] ]} onChange={ ({ target: { name, value } }) => { this.handleChange({ name, value }) } } />
                                <h2>Scale</h2>
                                <Input label='Width' name='scale.width' value={ this.state['scale.width'] } onChange={ debounce((e, name, value) => { this.handleChange({name, value }, 'number') }, 300) } />
                                <Input label='Height' name='scale.height' value={ this.state['scale.height'] } onChange={ debounce((e, name, value) => { this.handleChange({name, value}, 'number') }, 300) } />
                                <Select label='Profile' name='grayscale' value={ this.state['grayscale'] } options={[[false, 'Color'], [true, 'Monochrome']]} onChange={ ({ target: { name, value } }) => { this.handleChange({ name, value }) } } />
                                
                                <h2>Crop</h2>
                                <Input label='Width' name='crop.width' value={ this.state['crop.width'] } onChange={ debounce((e, name, value) => { this.handleChange({name, value}, 'number') }, 300) } />
                                <Input label='Height' name='crop.height' value={ this.state['crop.height'] } onChange={ debounce((e, name, value) => { this.handleChange({name, value}, 'number') }, 300) } />
                                <Input label='X' name='crop.x' value={ this.state['crop.x'] } onChange={ debounce((e, name, value) => { this.handleChange({name, value}, 'number') }, 300) } />
                                <Input label='Y' name='crop.y' value={ this.state['crop.y'] } onChange={ debounce((e, name, value) => { this.handleChange({name, value}, 'number') }, 300) } />
                            </div>
                            <div>
                                <h2>Image Information</h2>
                                <Detail title='Name' value={image.originalName} />
                                <Detail title='Dimensions' value={`${image.metadata.width} x ${image.metadata.height}`} />
                                <Detail title='Width' value={`${image.metadata.width} pixels`} />
                                <Detail title='Height' value={`${image.metadata.height} pixels`} />
                                <Detail title='Size' value={`${calculateSize(image.bucket.size)}`} />
                                <Detail title='Color Space' value={`${image.metadata.space}`} />
                                <Detail title='Resolution' value={`${image.metadata.density} dpi`} />

                                <Mutation 
                                    mutation={ DELETE_OBJECT }
                                    update={(cache, { data: { deleteObject: { id } } }) => {
                                        const { images, objectsConnection } = cache.readQuery({ query: GET_IMAGES })
                                        remove(images, (image) => {
                                            return image.id === id
                                        })
                                        cache.writeQuery({
                                            query: GET_IMAGES,
                                            data: { images, objectsConnection }
                                        })

                                        const test = cache.readQuery({ query: GET_IMAGES })
                                        console.log(test)
                                    }}
                                >
                                    {(deleteObject) => (
                                        <Button type='destructive' onClick={() => {
                                            console.log('OBJECT',objectId)
                                            deleteObject({
                                                variables: {
                                                    data: {
                                                        id: objectId
                                                    }
                                                }
                                            })
                                            .then((data) => {

                                                this.handleClose()
                                            })
                                        }}>Delete</Button>
                                    )}
                                </Mutation>

                            </div>
                        </Tabs>
                    </div>
                </div>
            </Modal>
        )
    }

}


// WEBPACK FOOTER //
// ./src/components/Editor/index.js